import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import { setup } from 'axios-cache-adapter';

const ajax = setup({
    baseURL: window.globals.api_url,
    cache: {
        maxAge: 20 * 60 * 1000, // 20min
        exclude: {
            query: false
        }
    },

    // withCredentials: true,

    // headers: {
    //     'x-requested-with': 'XMLHttpRequest',
    // },
});

const isExternal = (url) => {
    // console.log(new URL(url, location.origin).origin, window.globals.home_url);
    const or = new URL(url, location.origin).origin;
    const ur = new URL(window.globals.home_url, location.origin).origin;

    // console.log(or, ur, or.indexOf(ur) === -1)

    if (process.env.NODE_ENV === 'production') {
        return or.indexOf(ur) === -1;
    } else {
        return or.indexOf('http://127.0.0.1:8080') === -1;
    }
};


const app = createApp(App);
app.use(store);
app.use(router);
// app.provide('$ajax', ajax);
app.config.globalProperties.$ajax = ajax;
app.config.globalProperties.isExternal = isExternal;
app.mount('#app');

